import { useState } from "react";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import type { PortalContentKey } from "@colab/shared";
import { PortalContentDialog } from "./portal-content-dialog";

type Props = {
  variant?: "default" | "inline" | "empty";
  defaultKey?: PortalContentKey;
  label?: React.ReactNode;
};

export function NewPortalContentDialog({
  variant = "default",
  defaultKey,
  label,
}: Props) {
  const [open, setOpen] = useState(false);

  const triggerLabel = label ?? (
    <>
      <Plus className="mr-1.5 h-3.5 w-3.5" />
      New content row
    </>
  );

  return (
    <>
      {variant === "empty" ? (
        <Button onClick={() => setOpen(true)}>
          <Plus className="mr-2 h-4 w-4" />
          Create your first row
        </Button>
      ) : variant === "inline" ? (
        <Button variant="outline" size="sm" onClick={() => setOpen(true)}>
          {triggerLabel}
        </Button>
      ) : (
        <Button size="sm" onClick={() => setOpen(true)}>
          {triggerLabel}
        </Button>
      )}

      {open ? (
        <PortalContentDialog
          open={open}
          onOpenChange={setOpen}
          mode={{ kind: "create", defaultKey }}
        />
      ) : null}
    </>
  );
}
